<template>
  <v-dialog transition="dialog-bottom-transition" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        block
        color="tertiary"
        class="white--text mt-2 mb-0"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left> mdi-plus-thick </v-icon>
        Matching hinzufügen</v-btn
      >
    </template>
    <template v-slot:default="dialog">
      <v-card>
        <v-card-text class="pt-3 pb-0">
          <div
            class="text-h5 font-weight-medium text--primary"
            style="opacity: 0.8"
          >
            Matching hinzufügen
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pt-0 pb-1">
          <v-alert type="info" color="tertiary">
            <span title="It's not a bug, it's a feature! - Josef">
            Die CSVs bitte ohne Kopfzeile und Anführungszeichen angeben.</span>
          </v-alert>
          <form>
            <fieldset class="csc-mailform">
              <div class="csc-mailform-field">
                <v-text-field
                  class="my-4"
                  outlined
                  hide-details
                  label="Name"
                  append-icon="mdi-format-title"
                  v-model="title"
                />
                <v-file-input
                  class="my-4"
                  truncate-length="50"
                  label="Tutoren"
                  hint="Format: RBG-Kennung des Tutors, Anzahl der Tutorien (z.B. 'musterm, 2')"
                  persistent-hint
                  append-icon="mdi-paperclip"
                  outlined
                  prepend-icon=""
                  id="tutorsList"
                  name="tutors"
                  v-model="tutorsFile"
                  @change="readTutorsFile()"
                ></v-file-input>
                <v-file-input
                  class="my-4"
                  truncate-length="50"
                  label="Timeslots"
                  hint="Format: Tag, Beginn, Ende, Ist online?, Wie oft? (z.B. 'Mo, 08:00, 10:00, 1, 2')"
                  persistent-hint
                  append-icon="mdi-paperclip"
                  outlined
                  prepend-icon=""
                  id="tutorialsList"
                  name="tutorials"
                  v-model="timeSlotsFile"
                  @change="parseTutorialTimeslotFromCSV()"
                ></v-file-input>
              </div>
              <div v-if="tutors.length">
                <p>Tutors: {{ tutors.map((i) => i.login) }}</p>
              </div>
              <div class="csc-mailform-field" v-if="timeslots.length">
                <label>{{ timeslots.map((i) => timeslotToName(i)) }}</label>
              </div>
            </fieldset>
          </form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-end pt-0 pb-3">
          <v-btn text @click="dialog.value = false">Schließen</v-btn>
          <v-btn 
            color="primary" 
            text @click="uploadTutorAndTimeslot(dialog)"
            :disabled="!(tutors.length && timeslots.length && title)"
           >Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: "TutorialMatchingUpload",
  props: ["courseId"],
  data: function () {
    return {
      tutorsFile: null,
      timeSlotsFile: null,
      tutors: [],
      timeslots: [],
      title: "",
    };
  },
  methods: {
    readTutorsFile() {
      const tutorFile = this.tutorsFile;
      if (tutorFile) {
        const reader = new FileReader();
        reader.readAsText(tutorFile);
        reader.onload = (event) => {
          if (event.target) {
            this.tutors = event.target.result.trim()
              .split(/\r\n|\r|\n/)
              .map((i) => i.split(","))
              .map((i) => {
                return {
                  login: i[0].trim(),
                  tutorialNum: i[1].trim(),
                };
              })
              .filter((i) => i.login && i.tutorialNum);
          }
        };
      }
    },
    parseTutorialTimeslotFromCSV() {
      const tutorialsFile = this.timeSlotsFile;
      if (tutorialsFile) {
        const reader = new FileReader();
        reader.readAsText(tutorialsFile);

        reader.onload = (event) => {
          if (event.target) {
            this.timeslots = event.target.result.trim()
              .split(/\r\n|\r|\n/)
              .map((i) => i.split(","))
              .map((i) => {
                return {
                  day: i[0].trim(),
                  start: i[1].trim(),
                  end: i[2].trim(),
                  format: i[3].trim() === "1" ? "ONLINE" : "PRESENCE",
                  capacity: Number(i[4]),
                };
              });
          }
        };
      }
    },
    async uploadTutorAndTimeslot(dialog) {
      if (!this.timeslots.length || !this.tutors.length) {
        alert("Bitte alle Felder ausfüllen");
        return false;
      }
      const tutorUpload = await this.$axios.post(
        `courses/${this.courseId}/tutors/`,
        this.tutors
      );
      const preferenceUpload = await this.$axios.post(
        `courses/${this.courseId}/matching/`,
        { title: this.title, timeslots: this.timeslots }
      );

      if (tutorUpload.status != 204 || preferenceUpload.status != 204) {
        alert("Sorry, beim Server ist ein Fehler aufgetreten. :-/\nHTTP Fehler-Code: " + tutorUpload.status + " & " + preferenceUpload.status);
        return false;
      }
      dialog.value = false; // close the dialog box
      window.location.reload() // refresh list of matchings
      return true;
    },
  },
  setup() {
    const timeslotToName = (timeslot) => {
      return `${timeslot.day}-${timeslot.start}-${timeslot.format} x ${timeslot.capacity}`;
    };

    return {
      timeslotToName,
    };
  },
};
</script>

<style scoped></style>
